import { createColor } from '@manakin/theme/lib/color';

const grey = createColor('#FAFAFA');

export default grey;
